export const spacing = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '24px',
  xxl: '32px',
  xxxl: '48px'
};

// Mobile-specific spacing overrides for better touch UX
export const spacingMobile = {
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '20px',
  xl: '28px',
  xxl: '36px'
};

export const colors = {
  background: 'hsl(0deg 0% 97%)',
  backgroundPanel: 'hsl(0deg 0% 100%)',
  backgroundOffset: 'hsl(0deg 0% 93%)',
  foreground: 'hsl(0deg 0% 9%)',
  foregroundSecondary: 'hsl(240deg 1% 44%)',
  foregroundTertiary: 'hsl(240deg 2% 78%)',
  border: 'hsl(0deg 0% 91%)',
  borderLight: 'hsl(0deg 0% 88%)',
};

export const shadows = {
  xs: '0 1px 1px rgb(0 0 0 / 0.02)',
  sm: '0 1px 2px rgb(0 0 0 / 0.02), 0 2px 4px rgb(0 0 0 / 0.04)',
  md: '0 2px 2px rgb(0 0 0 / 0.02), 0 4px 8px rgb(0 0 0 / 0.06)',
};

export const borderRadius = {
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '20px',
  full: '9999px'
};